export type ApiGetPatentInitTabRequest = string;

export interface ApiGetPatentInitTabResponse {
    HAS_CUSTOMS: boolean;
    HAS_FILE_WRAPPER: boolean;
    HAS_LICENSE: boolean;
    HAS_LITIGATION: boolean;
    HAS_PLEDGE: boolean;
    HAS_REFERENCE: boolean;
    HAS_REREXAM: boolean;
    HAS_STANDARD: boolean;
    PN: string;
}

export const GetPatentInitTab = Symbol.for('GetPatentInitTab');

export interface GetPatentInitTab {
    getPatentInitTab(patentId: ApiGetPatentInitTabRequest): Promise<ApiGetPatentInitTabResponse>;
}
